import script from "./KnockoutItem.vue?vue&type=script&setup=true&lang=js"
export * from "./KnockoutItem.vue?vue&type=script&setup=true&lang=js"

import "./KnockoutItem.vue?vue&type=style&index=0&id=296dc08b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-296dc08b"]])

export default __exports__